module.exports = __webpack_public_path__ + "img/c25d56d.jpg";